function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { withTheme } from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { MainContent } from '@finect/tabular-core/MainContent';
import { FundSearchResult } from '@finect/tabular-components/Modules';
import { H1 } from '@finect/tabular-core/Headings';
import { withParams } from '@finect/front-core/withParams';
import { SearchBox } from '@finect/tabular-components/Products';
import { getProductTypeBySlug, getFundsHomePath } from '@finect/front-resources/Products';
import { Head } from '@finect/tabular-components/Head';
import { FamilyInsideNavigation } from '../commons/IIC/components';
const mapStateToProps = state => ({
  user: state.user
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({}, dispatch)
});
class Search extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      query: ''
    });
    _defineProperty(this, "handleInputChange", query => {
      this.setState({
        query
      });
    });
  }
  render() {
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    const {
      query
    } = this.state;
    return React.createElement(React.Fragment, null, React.createElement(Head, {
      title: `Buscador de ${productType.plural}`
    }), React.createElement(Helmet, null, React.createElement("title", null, "Resultados de b\xFAsqueda - Fondos - eleconomista.es"), React.createElement("meta", {
      name: "description",
      content: `Buscador de ${productType.plural}`
    })), React.createElement(Head, {
      title: `Resultados de búsqueda - ${productType.shortPlural}`,
      description: `Buscador de ${productType.plural}`,
      canonical: `${getFundsHomePath(this.props.theme, productType)}/buscar`
    }), React.createElement(Container, null, React.createElement(FamilyInsideNavigation, {
      productType: productType,
      current: "search"
    })), React.createElement(Container, null, React.createElement(ContainerInner, null, React.createElement(MainContent, null, React.createElement(H1, null, "Buscador de ", productType.plural.toLocaleLowerCase()), React.createElement(SearchBox, {
      compact: false,
      placeholder: `Escribe para buscar ${productType.singular.toLowerCase()}`,
      onChange: this.handleInputChange
    }), React.createElement(FundSearchResult, {
      productType: productType,
      query: query,
      limit: 10
    })))));
  }
}
export default withParams(connect(mapStateToProps, mapDispatchToProps)(withTheme(Search)));